import { render, staticRenderFns } from "./ButtonsGroup.vue?vue&type=template&id=b40aae12"
import script from "./ButtonsGroup.vue?vue&type=script&lang=js"
export * from "./ButtonsGroup.vue?vue&type=script&lang=js"
import style0 from "./ButtonsGroup.vue?vue&type=style&index=0&id=b40aae12&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports